// extracted by mini-css-extract-plugin
export default {"details-view-section":"details-view-section---FncfX","hide-separator":"hide-separator---oxCW0","details-view-section-label":"details-view-section-label---sEc_H"};